import React from "react";

const Payments = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M539.25-423Q491-423 457-457t-34-82.5q0-48.5 33.99-82.25t82.54-33.75q48.14 0 82.05 33.87 33.92 33.87 33.92 82.25T621.83-457q-33.66 34-82.58 34ZM222-283q-23.72 0-40.61-16.89T164.5-340.5V-738q0-23.72 16.89-40.61T222-795.5h635q23.72 0 40.61 16.89T914.5-738v397.5q0 23.72-16.89 40.61T857-283H222Zm98.5-57.5h438q0-41.5 28.87-70.25T857-439.5V-639q-41 0-69.75-28.75T758.5-738h-438q0 41.5-28.87 70.25T222-639v199.5q41 0 69.75 28.75t28.75 70.25Zm475 176H103q-23.72 0-40.61-16.89T45.5-222v-454.5H103V-222h692.5v57.5ZM222-340.5V-738v397.5Z" />
        </svg>

    )
}

export default Payments;